import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AboutPage from './pages/AboutPage';
import CredoPage from './pages/CredoPage';
import JoinFamilyPage from './pages/JoinFamilyPage';
import LocalesPage from './pages/LocalesPage';
import ContactPage from './pages/ContactPage';
import styles from './App.module.css';
import ShippingPage from './pages/ShippingPage';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import CheckoutPage from './pages/CheckoutPage';
import ITPage from './pages/ITPage';
import BackgroundMusic from './components/BackgroundMusic';

// Rutas del ERP: no deben mostrar el navbar ni la musica del e-commerce.
const ERP_ROUTES = ['/admin', '/it-diagnostics'];

const isErpRoute = (pathname: string) =>
  ERP_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));

/**
 * El navbar del e-commerce vive fuera de <Routes>, asi que sin este guard se
 * renderizaria tambien dentro del ERP (junto con el boton flotante de WhatsApp).
 */
const StorefrontChrome: React.FC = () => {
  const { pathname } = useLocation();
  if (isErpRoute(pathname)) return null;
  return (
    <>
      <Navbar />
      <BackgroundMusic />
    </>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className={styles.App}>
          <StorefrontChrome />

          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/productos" element={<ProductsPage />} />
            <Route path="/producto/:id" element={<ProductDetailPage />} />

            {/* Rutas de las páginas institucionales */}
            <Route path="/envios" element={<ShippingPage />} />
            <Route path="/locales" element={<LocalesPage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/credo" element={<CredoPage />} />
            <Route path="/familia" element={<JoinFamilyPage />} />

            {/* Rutas de Administración */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />

            {/* Checkout */}
            <Route path="/checkout" element={<CheckoutPage />} />

            {/* IT Diagnostics (Hidden) */}
            <Route path="/it-diagnostics" element={<ITPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
